import { useState, useEffect } from 'react';
import Select from 'react-select';
import { useSelector } from 'react-redux';

function PhoneNumberSelect({ prospect, onSelectionChange }) {
  const activeProspect = useSelector((s) => s?.conversation?.activeProspect);

  const [selected, setSelected] = useState([]);

  useEffect(() => {
    setSelected([]);
    onSelectionChange([]);
  }, [activeProspect?._id]);

  if (!activeProspect) return null;

  const phoneOptions = prospect.phoneInfo.map((phone) => ({
    value: phone.phoneNumber,
    label: phone.phoneNumber,
    phoneType: phone.phoneType,
    isValid: phone.phoneStatus,
  }));

  const handleChange = (selectedOptions) => {
    setSelected(selectedOptions || []);
    const numbers = (selectedOptions || []).map((opt) => opt.value);
    onSelectionChange(numbers);
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: 'transparent',
      border: '1px solid rgba(255,255,255,0.2)',
      boxShadow: 'none',
      minHeight: 'unset',
      cursor: 'pointer',
    }),
    valueContainer: (base) => ({
      ...base,
      padding: '2px 8px',
    }),
    input: (base) => ({
      ...base,
      color: 'white',
      margin: 0,
    }),
    placeholder: (base) => ({
      ...base,
      color: 'rgba(255,255,255,0.6)',
    }),
    singleValue: (base) => ({
      ...base,
      color: 'white',
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: 'rgba(255,255,255,0.15)',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: 'white',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: 'white',
      ':hover': {
        backgroundColor: 'rgba(255,255,255,0.3)',
        color: 'white',
      },
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: 'rgba(255,255,255,0.7)',
      padding: '4px',
    }),
    clearIndicator: (base) => ({
      ...base,
      color: 'rgba(255,255,255,0.7)',
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: '#1f1f1f',
      zIndex: 9999,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused
        ? 'rgba(255,255,255,0.1)'
        : 'transparent',
      color: 'white',
      cursor: 'pointer',
    }),
  };

  return (
    <Select
      key={activeProspect._id}
      isMulti
      options={phoneOptions}
      value={selected}
      onChange={handleChange}
      placeholder="Select number(s) to send SMS"
      closeMenuOnSelect={false}
      styles={customStyles}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      formatOptionLabel={(option, { context }) => {
        if (context === 'value') {
          return option.value;
        }

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span>{option.label}</span>
            {option.phoneType && (
              <span
                style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px' }}
              >
                ({option.phoneType})
              </span>
            )}
            {option.isValid ? (
              <span style={{ color: '#4ade80', fontSize: '12px' }}>
                ✓ Verified
              </span>
            ) : (
              <span style={{ color: '#fb923c', fontSize: '12px' }}>
                Unverified
              </span>
            )}
          </div>
        );
      }}
    />
  );
}

export default PhoneNumberSelect;
